<section class="page-wrap animated fadeIn">

  <header class="pattern-header">
    School Field Trips
  </header>

  <div class="header-imgs">
    <img src="/assets/images/landing/farm-activities/school-trips/trip-1.webp" alt="Image of">
    <img src="/assets/images/landing/farm-activities/school-trips/trip-2.webp" alt="Image of">
  </div>

  <div class="d-flex justify-content-center align-items-center mb-5">
    <div class="landing-container d-flex flex-column gap-4">
      @for (item of trips(); track $index) {
      <div class="trip-card animated fadeInDown">
        <div class="trip-card__content">
          <div>
            <h3 class="h4-bold">
              {{item.title}}
            </h3>
            <div class="h6-regular" [innerHTML]="item.description"></div>
          </div>
          <a class="btn btn-primary" target="_blank" rel="noopener" href="https://calendly.com/carltonfarms/3hours">
            Schedule your trip
          </a>
        </div>
      </div>
      }
    </div>
  </div>

</section>